const React = require('react');
const classNames = require('classnames');

class Section extends React.Component {
    state = {
        showSection: false
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.defaultSection) {
            this.setState({
                showSection: true
            });
        }
    }

    toggleSection = (event) => {
        event.preventDefault();
        this.setState({
            showSection: !this.state.showSection
        })
    };

    render() {
        const classes = classNames({
            fas: true,
            'fa-caret-down': !this.state.showSection,
            'fa-caret-up': this.state.showSection
        });

        const cardBodyClasses = classNames({
            'card-body': true,
            collapsed: !this.state.showSection
        });

        return (
            <div className="section">
                {/*use a random ID to force rerendering of the SVG*/}
                <div key={Math.random()} className="card-header section-heading" onClick={this.toggleSection}>
                    {this.props.title} <i className={classes}/>
                </div>

                <div className={cardBodyClasses}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}

module.exports = Section;
